interface MailFolderListProps {
  unreadCount: number;
  uiMutationId?: string;
  selectedFolder: string;
  onSelect: (folder: string) => void;
}

const folders = [
  ["inbox", "受信箱"],
  ["sent", "送信済み"],
  ["drafts", "下書き"],
  ["trash", "削除済み"]
] as const;

export function MailFolderList({ unreadCount, uiMutationId, selectedFolder, onSelect }: MailFolderListProps) {
  const shownUnread = unreadCount + (uiMutationId === "unread_count_mismatch" ? 1 : 0);
  return (
    <nav className="mail-folders" aria-label="メールフォルダ">
      <div className="mail-account">nightwatch@to-oh.local</div>
      {folders.map(([id, label]) => {
        const shownLabel = uiMutationId === "folder_retired" && id === "sent" ? "退職者" : label;
        return (
          <button
            type="button"
            key={id}
            className={selectedFolder === id ? "folder-button is-active" : "folder-button"}
            onClick={() => onSelect(id)}
          >
            <span>{shownLabel}</span>
            {id === "inbox" && <span className="folder-count">{shownUnread}</span>}
          </button>
        );
      })}
      <div className="folder-separator" />
      <div className="folder-status">接続: 社内LAN</div>
      <div className="folder-status">暗号化: 有効</div>
    </nav>
  );
}
